import React, { useState } from "react";
import ReportTable from "../components/reportTable";
import { columnsConfig } from "./reportColumns";
import ReportFilters from "../components/reportFilter";

const PrincipalReport = () => {
    const [filters, setFilters] = useState({ from: "", to: "" });
    return (
        <>
            <ReportFilters filters={filters} setFilters={setFilters} />
            <ReportTable
                title="Principal Received Report"
                endpoint="reports/principal"
                columns={columnsConfig.principalReport}
                filters={filters}
            />
            </>
    );
};

export default PrincipalReport;